<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";
import Layout from "./router/layouts/main.vue";
import { mapGetters } from "vuex";

export default {
  components: { Layout },
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    yourCallBackFunction () {
      console.log('backbutton');
    },
  },
  computed: {
    ...mapGetters("authfack", ["getLoginLoading"]),
  },
  mounted () {
    window.addEventListener('popstate', event => {
      console.log('popstate User clicked back button', event);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
  },
};
</script>

<template>
  <div id="app" v-if="!getLoginLoading">
    <div v-if="$route.meta.noLayout">
      <RouterView :key="$route.fullPath" />
    </div>
    <Layout v-else>
      <RouterView :key="$route.fullPath" />
    </Layout>
  </div>
</template>
